import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

const TPO_CERTIFICATION_ROUTING_PARAMS = {
  subCompanyId: 'subCompanyId',
};

export class TpoCertificationPaths {
  static tpoCertification = new EnhancedPath('/tpo-certification');

  static subCompany = new EnhancedPath(
    `${TpoCertificationPaths.tpoCertification.path}/:${TPO_CERTIFICATION_ROUTING_PARAMS.subCompanyId}`,
  );
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: TpoCertificationPaths.subCompany.path,
      component: lazyWithRetry(() => import('app/pages/tpoCertification')),
      exact: true,
      isAllowedWithoutRoles: true,
    },
    {
      path: TpoCertificationPaths.tpoCertification.path,
      component: lazyWithRetry(() => import('app/pages/tpoCertification')),
      exact: true,
      isAllowedWithoutRoles: true,
    },
  ],
};

export default routesConfig;
